import React, { useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { Collapse, Container, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import I18n from '../../blocks/localization';
import { Language } from '../../blocks/localization/Language';
import RoutesConst from '../../blocks/consts/RoutesConst';
import { ApplicationState } from '../../store';
import { BUS_LINES_URL, PROMET_CONTACT_MAIL, PROMET_CONTACT_PHONE } from '../../config';
import { logoutActions } from '../../store/auth/actions';
import { changeLanguageActions } from '../../store/account/actions';
import promet_logo from '../../assets/images/promet-logo.png';
import icon_unknown_user from '../../assets/icons/1x/icon_ne-logirani-korisnik.png';
import icon_logged_in_user from '../../assets/icons/1x/icon_logirani-korisnik.png';
import icon_penalty_pay from '../../assets/icons/1x/penalty_pay_24px.png';
import icon_e_novcanik from '../../assets/icons/1x/icon_e-novcanik.png';
import icon_faq from '../../assets/icons/1x/icon-faq.png';
import icon_selling_spots from '../../assets/icons/1x/icon_prodajna-mjesta.png';
import icon_bus_lines from '../../assets/icons/1x/icon_vozni-red.png';
import icon_my_coupons from '../../assets/icons/1x/icon_moji-kuponi.png';
import icon_transaction from '../../assets/icons/1x/icon-transaction.png';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import MenuOutlinedIcon from '@material-ui/icons/MenuOutlined';
import SessionStorageConst from '../../blocks/consts/SessionStorageConst';

type Props = typeof mapDispatchToProps;

const NavMenu = (props: Props) => {
    const [isToggleOpen, setIsToggleOpen] = useState<boolean>(false);

    const history = useHistory();

    const isAuthenticated = useSelector((state: ApplicationState) => state.auth.isAuthenticated);
    const account = useSelector((state: ApplicationState) => state.account.account);
    
    const language = sessionStorage.getItem(SessionStorageConst.Language) as Language;
    const busLinesUrl = BUS_LINES_URL[language];

    const changeLanguage = (language: Language) => {
        props.changeLanguage(language);
    }

    const toggle = () => {
        setIsToggleOpen(!isToggleOpen);
    }

    const redirect = (route: string) => {
        history.push(route);
        toggle();
    }

    const getLanguageText = (): string => {
        const language = sessionStorage.getItem(SessionStorageConst.Language) as Language || '';
        return language.toUpperCase();
    }

    const getUserFullName = (): string => {
        if (!account)
            return '';

        if (account.firstName || account.lastName)
            return `${account.firstName} ${account.lastName}`;

        return account.email;
    }

    const logout = () => {
        props.logout();
    }

    const getContactPhoneNumber = (): string => {
        return PROMET_CONTACT_PHONE.replace(' ', '');
    }

    return (
        <header>
            <Navbar className="navbar-expand-sm navbar-toggleable-sm border-bottom mb-3">
                <Container fluid>
                    <NavbarToggler onClick={toggle}>
                        <MenuOutlinedIcon />
                    </NavbarToggler>

                    <NavbarBrand tag={Link} to={RoutesConst.Home}>
                        <img src={promet_logo} alt="promet-logo" />
                    </NavbarBrand>

                    <ul className="navbar-nav" id="headerLanguage">
                        <li className="nav-item dropdown" id="navigationLanguage">
                            <Link to={{}} className="nav-link dropdown-toggle" id="navbarDropdownMenuLanguage" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {getLanguageText()}
                            </Link>
                            <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLanguage">
                                <Link to={{}} className="dropdown-item" onClick={() => changeLanguage('hr')}>HR</Link>
                                <Link to={{}} className="dropdown-item" onClick={() => changeLanguage('en')}>EN</Link>
                            </div>
                        </li>
                    </ul>
                    <span className="ml-5" id="headerContactEmail">
                        <a href={`mailto:${PROMET_CONTACT_MAIL}`}>
                            <MailOutlineIcon className="secondary-color mr-1" />
                            <span className="header-contact-info">{PROMET_CONTACT_MAIL}</span>
                        </a>
                    </span>
                    <span className="ml-4 mr-auto" id="headerContactPhone">
                        <a href={`tel://:${getContactPhoneNumber()}`}>
                            <PhoneEnabledIcon className="secondary-color mr-1" />
                            <span className="header-contact-info">{PROMET_CONTACT_PHONE}</span>
                        </a>
                    </span>
                    <ul className="navbar-nav">
                        {
                            !isAuthenticated &&
                            <NavItem>
                                <NavLink tag={Link} to={RoutesConst.Login} className="font-weight-500">
                                    <img src={icon_unknown_user} alt="ne logirani korisnik" />
                                    {I18n.t('navigation.login')}
                                </NavLink>
                            </NavItem>
                        }
                        {
                            isAuthenticated &&
                            <>
                                <li className="nav-item dropdown" id="navigationUser">
                                    <Link to={{}} className="nav-link dropdown-toggle font-weight-500" id="navbarDropdownMenuUser" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <img src={icon_logged_in_user} alt="ne logirani korisnik" />
                                        <span id="headerUsername">{getUserFullName()}</span>
                                    </Link>

                                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuUser">
                                        <Link to={RoutesConst.Dashboard} className="dropdown-item">{I18n.t('navigation.dashboard')}</Link>
                                        <Link to={RoutesConst.MyProfile} className="dropdown-item">{I18n.t('navigation.myProfile')}</Link>
                                        <Link to={{}} className="dropdown-item" onClick={() => logout()}>{I18n.t('navigation.logout')}</Link>
                                    </div>
                                </li>
                            </>
                        }
                    </ul>

                    <Collapse isOpen={isToggleOpen} navbar id="headerCollapse">
                        <Nav className="ml-auto" navbar>
                            <NavItem>
                                <NavLink to={{}} onClick={() => redirect(RoutesConst.EWallet)}>
                                    <img src={icon_e_novcanik} alt="eNovčanik" />
                                    <span>{I18n.t('leftNavigation.eWallet')}</span>
                                </NavLink>
                                <NavLink onClick={() => redirect(RoutesConst.PenaltyPay)} className="border-top">
                                    <img src={icon_penalty_pay} alt="penaltyPayment" />
                                    {I18n.t('login.info.penalty')}
                                </NavLink>
                                {
                                    isAuthenticated && account?.clientId &&
                                    <NavLink to={{}} onClick={() => redirect(RoutesConst.MyCoupons)}>
                                        <img src={icon_my_coupons} alt="kuponi" />
                                        <span>{I18n.t('leftNavigation.myCoupons')}</span>
                                    </NavLink>
                                }
                                {
                                    isAuthenticated &&
                                    <NavLink to={{}} onClick={() => redirect(RoutesConst.MyTransactions)}>
                                        <img src={icon_transaction} alt="transkacije" />
                                        <span>{I18n.t('leftNavigation.myTransactions')}</span>
                                    </NavLink>
                                }
                                <NavLink to={{}}>
                                    <a href={busLinesUrl} target="_blank">
                                        <img src={icon_bus_lines} alt="Vozni red" />
                                        {I18n.t('login.info.busLines')}
                                    </a>
                                </NavLink>
                                {/* <NavLink to={{}} onClick={() => redirect(RoutesConst.RouteCalculation)}>
                                    <img src={icon_mapa} alt="Izračun rute" />
                                    <span>{I18n.t('leftNavigation.routeCalculation')}</span>
                                </NavLink> */}
                                <NavLink to={{}} onClick={() => redirect(RoutesConst.SellingSpots)}>
                                    <img src={icon_selling_spots} alt="Prodajna mjesta" />
                                    <span>{I18n.t('leftNavigation.sellingSpots')}</span>
                                </NavLink>
                                <NavLink to={{}} onClick={() => redirect(RoutesConst.FrequentylAskedQuestions)}>
                                    <img src={icon_faq} alt="Česta pitanja" />
                                    <span>{I18n.t('leftNavigation.frequentlyAskedQuestions')}</span>
                                </NavLink>
                            </NavItem>
                        </Nav>
                    </Collapse>
                </Container>
            </Navbar>
        </header>
    )
}

const mapDispatchToProps = {
    logout: logoutActions.request,
    changeLanguage: changeLanguageActions.request
};

export default connect(null, mapDispatchToProps)(NavMenu as any);
